<template>
    <tr class="lms__superadmin_workspaces_edit_certificates_table_item">
        <td class="lms__superadmin_workspaces_edit_certificates_table_name">{{ certificateName }}</td>
        <td class="lms__superadmin_workspaces_edit_certificates_table_status">
            <component-status
                v-if="certificateIsWorkspaceDefault"
                :status="'default'"
            />
        </td>
        <td class="lms__superadmin_workspaces_edit_certificates_table_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <template v-if="!certificateBlank">
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-workspace-edit-email-certificates-table-item-edit-action'"
                            :theme="'default'"
                            @click="performEmit('emit-edit', certificateId)"
                        >Edit
                        </component-button>
                    </div>
                </template>
                <template v-if="buttonMenuList.length">
                    <div class="column is-narrow">
                        <component-button-menu
                            :buttons="buttonMenuList"
                            @emit-preview="performEmit('emit-preview', { contentId: certificateId, name: certificateName })"
                            @emit-set-default="performEmit('emit-set-default', { workspaceId: certificateWorkspaceId, certificateContentId: certificateId })"
                            @emit-unset-default="performEmit('emit-unset-default', certificateWorkspaceId)"
                            @emit-delete="performEmit('emit-delete', certificateId)"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'

export default {
  name: 'lms-superadmin-workspace-edit-certificates-table-item',
  components: { ComponentButtonMenu, ComponentButton, ComponentStatus },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    certificateName () {
      return this.item.name
    },
    certificateIsWorkspaceDefault () {
      return this.item.workspaceDefault
    },
    certificateId () {
      return this.item.id || null
    },
    certificateBlank () {
      return this.item.blank
    },
    certificateWorkspaceId () {
      return this.item.workspaceId || this.$route.params.id
    },
    certificateHtml () {
      return this.item.html
    },
    certificateHeader () {
      return this.item.logo
    },
    certificateFooter () {
      return this.item.footer
    },
    buttonMenuList () {
      let listArr = []

      listArr.push({
        key: 'preview',
        name: 'Preview'
      })
      if (this.certificateIsWorkspaceDefault && !this.certificateBlank) {
        listArr.push({
          key: 'unset-default',
          name: 'Unset default certificate'
        })
      } else if (this.certificateBlank) {
        if (!this.certificateIsWorkspaceDefault) {
          listArr.push({
            key: 'unset-default',
            name: 'Make default certificate'
          })
        }
      } else {
        listArr.push({
          key: 'set-default',
          name: 'Make default certificate'
        })
        listArr.push({
          key: 'delete',
          name: 'Delete'
        })
      }

      return listArr
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message, value })
    }
  }
}
</script>
